<!-- Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. -->
<tp-multi-panel-header
	*ngIf="!isTicketListPanelCollapsed"
	class="sort-list-header"
	(isCollapsed)="isTicketListPanelCollapsed = $event"
>
	<mat-form-field subscriptSizing="dynamic" class="sort-by-list">
		<mat-label>{{ appStrings.PLAN_FILTER_TICKET_LIST_SORT }}</mat-label>
		<mat-select [formControl]="sortTicketsControl">
			<mat-option *ngFor="let entry of sortTicketListOptions | keyvalue" [value]="entry.value">
				{{ entry.key }}
			</mat-option>
		</mat-select>
	</mat-form-field>
</tp-multi-panel-header>
<tp-multi-panel-header
	*ngIf="isTicketListPanelCollapsed"
	class="sort-list-header"
	(isCollapsed)="isTicketListPanelCollapsed = $event"
>
	<h1>{{ appStrings.PLAN_FILTER_TICKET_LIST_TITLE }}</h1>
</tp-multi-panel-header>
<tp-multi-panel-content>
	<mat-divider></mat-divider>
	<div class="transparency-slider-control">
		<mat-label>Filter transparency</mat-label>
		<div class="slider-row">
			<span>Solid</span>
			<mat-slider max="100" min="0" step="1" discrete>
				<input matSliderThumb [formControl]="transparency" />
			</mat-slider>
			<span>Clear</span>
		</div>
	</div>
	<tp-ticket-list-panel
		[tickets]="filteredSortedTickets$ | async"
		(ticketClick)="onFocusOnTicket($event)"
	></tp-ticket-list-panel>
</tp-multi-panel-content>
